import { createComponent } from '@carvana/merch-components';

export const BadgeText = createComponent('p', {
  className: 'px-16 text-white tl-header-xs'
});

const Wrapper = createComponent('div', {
  className: `flex h-24 w-fit items-center rounded`,
  'data-qa': 'hero-header-badge'
});

export const BlueWrapper = createComponent(Wrapper, {
  className: 'bg-blue-2'
});

export const RedWrapper = createComponent(Wrapper, {
  className: 'bg-red-2'
});

export const YellowWrapper = createComponent(Wrapper, {
  className: 'bg-yellow-2'
});
